<template>
  <v-card
    v-if="
      checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
    "
    class="mt-16"
    flat
  >
    <v-row justify="center" align="center">
      <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
    </v-row>
    <v-row justify="center" align="center">
      <v-card-subtitle class="subtitle-1"
        >You do not have Permission to access.</v-card-subtitle
      >
    </v-row>
  </v-card>
  <v-card class="ma-1" v-else>
    <v-row class="mt-1">
      <!-- <v-card-title class="primary--text">
        User Management
        <v-divider vertical class="ml-5 mx-0"></v-divider>
      </v-card-title>-->
      <v-card-actions />
      <v-spacer />
      <v-spacer />
      <v-spacer />

      <!-- 
      <v-col>
        <v-dialog persistent v-model="AddUser" width="600">
          <v-toolbar dark class="gradient-bg2">
            <v-toolbar-items
              ><v-toolbar-title class="white--text titcss ml-3 mt-4"
                >Add User</v-toolbar-title
              >
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn class="" text dark @click="AddUser = false">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <template #activator="{ on: AddUser }">
            <v-tooltip bottom color="primary">
              <template #activator="{ on: tooltip }">
                <v-btn
                  class="primary white--text"
                  v-on="{ ...AddUser, ...tooltip }"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </template>
              <span class="white--text">Add a New user</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-divider></v-divider>
            <v-form ref="form">
              <v-row class="mt-8 mx-7">
                <v-text-field
                  v-model="Name"
                  label="Name *"
                  color="primary"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-row>
              <v-row class="mx-7">
                <v-text-field
                  v-model="Mobilenumber"
                  color="primary"
                  label="Mobile Number *"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-row>
              <v-row class="mx-7">
                <v-select
                  label="Proxy Number *"
                  v-model="proxynumber"
                  :items="proxynumbers"
                  outlined
                  dense
                >
                </v-select>
              </v-row>
                    <v-row class="mx-7">
                <v-select
                  label="Department *"
                  v-model="Department"
                  :items="Departments"
                  outlined
                  dense
                >
                </v-select>
              </v-row>
              <v-row class="mr-7 mb-8">
                <v-spacer></v-spacer>
                <v-card-actions>
                  <v-btn
                    class="primary mr-n2 white--text"
                    :loading="isLoading"
                    medium
                    ><v-icon class="mr-2 ml-n2">mdi-plus</v-icon>
                    Add User
                  </v-btn>
                </v-card-actions>
              </v-row>
            </v-form>
            <v-card-actions> </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>-->
    </v-row>
    <!-- <v-divider class="mt-n2 mx-0"></v-divider> -->
    <v-row class="ml-1 mt-3 mb-n3">
      <v-col cols="12" md="3" xs="12" sm="12" lg="3" xl="3">
        <v-select
          label="Status"
          outlined
          dense
          return-object
          item-text="name"
          item-value="value"
          v-model="status"
          :items="statuss"
          class="mr-3"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" xs="12" sm="12" lg="3" xl="3">
        <v-select
          label="Sub-Card Type"
          outlined
          dense
          return-object
          v-model="cartype"
          :items="cardtypes"
          item-text="name"
          item-value="value"
          class="mr-3"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" xs="12" sm="12" lg="3" xl="3">
        <v-text-field
          v-model="search"
          shaped
          outlined
          dense
          class="mt-0"
          color="primary"
          append-icon="mdi-magnify"
          label="Search"
          hint="search by mobile number"
        ></v-text-field>
      </v-col>
      <v-card-actions>
        <v-btn
          text
          color="primary"
          fab
          class="mt-n7 ml-n2"
          @click="getcarduserdetails"
        >
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-row>

    <v-card>
      <v-card-text>
        <v-col cols="12" sm="12" xs="12" md="12" xl="12" lg="12">
          <v-data-table
            dense
            :headers="headers"
            :items="userDatalist"
            item-key="name"
            :options.sync="pagination"
            :items-per-page="itemsPerPage"
            @update:options="getcarduserdetailsPagination()"
            :no-data-text="Nodata"
            :item-class="itemRowBackground"
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ userDatalist.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:[`item.pack_reference_id`]="{ item }">
              <span
                class="caption grey--text"
                v-if="
                  item.pack_reference_id != null &&
                  item.status == 'Ready to Assign'
                "
                >{{ item.pack_reference_id }}</span
              >
              <span
                class="caption"
                v-if="
                  item.pack_reference_id != null &&
                  item.status != 'Ready to Assign'
                "
                >{{ item.pack_reference_id }}</span
              >
              <span class="caption" v-if="item.pack_reference_id == null"
                >-</span
              >
            </template>

            <template v-slot:[`item.proxy_number`]="{ item }">
              <span class="caption">{{ item.proxy_number }}</span>
            </template>
            <template v-slot:[`item.card_status`]="{ item }">
              <span class="caption" v-if="item.card_status == '400'"> - </span>
              <span
                class="caption red--text"
                v-if="item.card_status == 'INACTIVE'"
              >
                INACTIVE
              </span>
              <span
                class="caption primary--text"
                v-if="item.card_status == 'SUSPENDED'"
              >
                SUSPENDED
              </span>
              <span
                class="caption red--text"
                v-if="item.card_status == 'TERMINATED'"
              >
                TERMINATED
              </span>
              <span
                class="caption green--text"
                v-if="item.card_status == 'ACTIVE'"
                >ACTIVE</span
              >
              <span
                class="caption green--text"
                v-if="item.card_status == 'active'"
                >ACTIVE</span
              >
              <span
                class="caption red--text"
                v-if="item.card_status == 'LOCKED'"
              >
                LOCKED
              </span>
              <span
                class="caption red--text"
                v-if="item.card_status == 'BLOCKED'"
              >
                BLOCKED
              </span>
            </template>
            <template v-slot:[`item.first_name`]="{ item }">
              <span
                class="caption"
                v-if="
                  item.first_name != null && item.status != 'Click to Assign'
                "
                ><b>{{ item.first_name }}</b></span
              >
              <span
                class="caption"
                v-if="
                  item.first_name != null && item.status == 'Click to Assign'
                "
                >{{ item.first_name }}</span
              >
              <br />
              <span class="caption">{{ item.phone_number }}</span>
              <span class="caption" v-if="item.first_name == null">-</span>
            </template>
            <template v-slot:[`item.middle_name`]="{ item }">
              <span class="caption" v-if="item.middle_name != null">{{
                item.middle_name
              }}</span>
              <span class="caption" v-if="item.middle_name == null">-</span>
            </template>
            <template v-slot:[`item.last_name`]="{ item }">
              <span class="caption" v-if="item.last_name != null">{{
                item.last_name
              }}</span>
              <span class="caption" v-if="item.last_name == null">-</span>
            </template>
            <template v-slot:[`item.email_id`]="{ item }">
              <span class="caption" v-if="item.email_id != null">{{
                item.email_id
              }}</span>
              <span class="caption" v-if="item.email_id == null">-</span>
            </template>
            <!-- <template v-slot:[`item.phone_number`]="{ item }">
              <span class="caption" v-if="item.phone_number != null"
                >+60 {{ item.phone_number }}</span
              >
              <span class="caption" v-if="item.phone_number == null">-</span>
            </template> -->
            <template v-slot:[`item.sub_card_type`]="{ item }">
              <!-- <span
              class="caption"
              v-if="
                item.card_details.sub_cardtype == undefined ||
                item.card_details.sub_cardtype === null
              "
              >-</span
            > -->
              <span class="caption" v-if="item.card_details.sub_card_type == 1"
                >Physical card</span
              >
              <span class="caption" v-if="item.card_details.sub_card_type == 2"
                >Virtual card</span
              >
            </template>
            <template v-slot:[`item.created_on`]="{ item }">
              <span class="caption">{{ item.created_on }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                @click="assigncard(item)"
                :class="getClassforStatus(item.status)"
                class="status"
              >
                <template v-if="item.status === 'Click to Assign'">
                  <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.status }}</span>
                    </template>
                    <!-- Tooltip content for 'Click to Assign' status -->
                    <span>Click to assign first card</span>
                  </v-tooltip>
                </template>
                <template v-else-if="item.status === 'Ready to Assign'">
                  <span v-on="on">Click to assign</span>
                </template>
               
                <template v-else>
                  {{ item.status }} <v-icon
                small
               v-if="item.status === 'Rejected'"
                class="ml-3"
                color="
                       primary
                      "
                @click="Resubmit(item)"
                >mdi-account-convert</v-icon
              >
                </template>
              </span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <span>
                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      v-on="on"
                      color="primary"
                      v-if="item.is_director == '1'"
                      >mdi-account-card</v-icon
                    ></template
                  >
                  <span>First Card </span>
                </v-tooltip>
              </span>
            </template>

            <template v-slot:[`item.View`]="{ item }">
              <v-icon
                small
                @click="opendeatils(item, '1')"
                color="primary"
                v-if="isViewDetailVisibile(item.status)"
                >mdi-eye</v-icon
              >
             
              <v-icon
                small
                v-if="
                  item.status != 'Click to Assign' && 
                  item.status != 'Ready to Assign' &&
                  item.status != 'DELETED' &&
                  item.status != 'Pending for Deletion'
                  
                "
                class="ml-3"
                color="
                       red
                      "
                @click="Deactivate(item)"
                >mdi-account-remove</v-icon
              >
             
            </template>
          </v-data-table>
        </v-col>
      </v-card-text>
    </v-card>
    <AssignCard ref="assigncard" v-on:backChild="getcarduserdetails" />
    <acknowledge ref="acknowledge" />
    <mappeduser ref="mappeduser" />
    <Viewpersonalizeddetails
      ref="viewdetails123"
      :approver1="approver1"
      :approver2="approver2"
      :userbudget="userbudget"
      :carddetails="carddetails"
      :itemUsers="itemUsers"
    />
    <OverleyProccessg :overlay="overlay" />
    <v-dialog
      v-model="deactivate_dialog"
      persistent
      max-width="600px"
      v-if="CardBalance == 0"
    >
      <v-card>
        <v-toolbar flat class="header" dark dense>
          <v-icon>mdi-account-remove</v-icon>
          <span class="ml-3">Remove User</span>

          <v-spacer></v-spacer>
          <v-icon small class="white--text" dark @click="dialogclose()"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-10">
          <v-row>
            <v-col cols="12" sm="12" xs="12" lg="12" xl="12" md="12">
              <div class="black--text text--darken-1" style="font-size: 15px">
                <div>
                  Are you sure you want to
                  <b class="primary--text">Remove </b> user
                  <b class="primary--text">{{ FirstName }} ?</b>
                  <br />

                  <br />
                  <span
                    style="font-style: italic; font-family: Times New Roman"
                    class="text-left font-weight: 20 primary--text mt-9 ml-0"
                    >By doing this action users account gets deleted and card
                    gets <br />
                    terminated permanently.</span
                  >
                </div>
              </div>
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-col
              cols="12"
              sm="12"
              xs="12"
              lg="12"
              xl="12"
              md="12"
              class="mt-3 ml-n3"
            >
              <v-textarea
                dense
                rows="1"
                outlined
                label="Remarks"
                v-model="comments"
                :rules="Namerules"
              ></v-textarea>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="Deactive()">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="resubmit_dialog"
      persistent
      max-width="600px"
      
    >
      <v-card>
        <v-toolbar flat class="header" dark dense>
          <v-icon>mdi-account-convert</v-icon>
          <span class="ml-3">Re-Initiate User - {{ FirstName }}</span>

          <v-spacer></v-spacer>
          <v-icon small class="white--text" dark @click="dialogclosereSubmit()"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-10">
          <v-row>
            <v-col cols="12" sm="12" xs="12" lg="12" xl="12" md="12">
              <div class="black--text text--darken-1" style="font-size: 15px">
                <div> 
                  Are you sure you want the user to Re-initiate the process ?
                   
                 
                  <br />

                  <br />
                  <span
                    style="font-style: italic; font-family: Times New Roman"
                    class="text-left font-weight: 20 primary--text mt-9 ml-0"
                    >

By re-initiating this request, the user will need to start the process from the beginning,<br/>
 and any previous rejection will be reviewed for reconsideration.</span
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        
         
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="ResubmitCnfrm()" :loading="loading">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogapprv" persistent max-width="400px">
      <v-card>
        <v-card-text class="pt-2">
          <div class="primary--text text--darken-1" style="font-size: 15px">
            <div>Are you sure you want to <b>Remove</b> User?</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="red" rounded text @click="dialogcloseApprv()">No</v-btn>
          <v-btn text class="primary--text" small @click="Deactiveuser()"
            >YES</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="Nodeactive" persistent max-width="500px">
      <v-toolbar flat class="header" dark dense>
        <v-icon>mdi-account-remove</v-icon>
        <span class="ml-3">Remove User</span>

        <v-spacer></v-spacer>
        <v-icon small class="white--text" dark @click="dialogcloseApprvnew()"
          >mdi-close</v-icon
        >
      </v-toolbar>
      <v-card>
        <v-card-text class="pt-4">
          <div
            style="
              font-size: 15px;
              font-style: italic;
              font-family: Times New Roman;
            "
            class="black--text"
          >
            You cannot perform this action for the User
            <span style="font-size: 18px"
              ><b>{{ FirstName }} </b></span
            >
            as the Card Balance is

            <span style="font-size: 18px"
              ><b> {{ CardBalance }} MYR</b></span
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            small
            @click="dialogcloseApprvnew()"
            class="mt-n2"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletependingDialog" height="500" width="570" persistent>
      <v-card class="overflow-hidden" rounded="md">
        <v-card-text
          style="
            font-style: normal;
            font-size: 18px;
            font-family: Times New Roman;
            margin-top: 30px;
          "
          class="font-weight-light black--text"
        >
          The user deletion request is complete and awaiting admin approval.
        </v-card-text>

        <v-card-actions>
          <v-row class="mt-n6">
            <v-col cols="12" md="4"> </v-col>
            <v-col cols="12" md="5"></v-col>
            <v-col cols="12" md="2" class="mt-6">
              <v-btn color="primary " text @click="closeDialog"> close </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="deactivate_dialog2" persistent max-width="600px">
      <v-card>
        <v-toolbar color="white" dark class="elevation-0">
         
          <v-toolbar-title class="black--text ml-2" >
            <b>ACTIVATE USER</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon medium class="black--text mt-n4" dark @click="dialogclose2()"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text class="pt-2">
          <div class="grey--text text--darken-1" style="font-size: 15px">
           
            <div >
              Are you sure you want to <b>ACTIVATE </b> user
              <b> ?</b>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="activeuser()">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-card>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
// import moment from "moment";
import AssignCard from "@/Views/users/AssignCard.vue";
import acknowledge from "@/Views/users/acknowledge.vue";
import mappeduser from "@/Views/users/mappeduser.vue";
import Viewpersonalizeddetails from "@/Views/users/viewpersonalizesdetails.vue";

import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    AssignCard,
    acknowledge,
    mappeduser,
    OverleyProccessg,
    Viewpersonalizeddetails,
  },
  data: () => ({
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    checkaccessdata: {},
    dialogapprv: false,
    comments: "",
    overlay: false,
    approver1: {},
    approver2: {},
    userbudget: {},
    carddetails: {},
    itemUsers: {},
    on: "",
    userDatalist: [],
    Nodata: "",
    AddUser: false,
    status: "All",
    search: "",
    getcardlist: [],
    CardBalance: 0,
    loading:false,
    statuss: [
      {
        name: "All",
        value: 0,
      },
      // {
      //   name: "In Stock",
      //   value: 1,
      // },

      {
        name: "Ready to Assign",
        value: 4,
      },
      {
        name: "Mapped to User",
        value: 5,
      },
      // {
      //   name: "Assigned to User ",
      //   value: 6,
      // },
      // {
      //   name: "KYC Pending ",
      //   value: 8,
      // },
      // {
      //   name: "KYC Failed ",
      //   value: 9,
      // },
      // {
      //   name: "Activation Pending ",
      //   value: 10,
      // },
      // {
      //   name: "Activate User ",
      //   value: 11,
      // },
      // {
      //   name: "Blocked ",
      //   value: 7,
      // },
    ],
    cartype: 0,
    kyc: true,
    cardtypes: [
      {
        name: "All ",
        value: 0,
      },
      {
        name: "Physical Card ",
        value: 1,
      },
      {
        name: "Virtual Card ",
        value: 2,
      },
    ],
    headers: [
      { text: "SL NO", value: "sl_no", align: "left", sortable: false },
      // {
      //   text: "Phone Number",
      //   value: "Phno",
      // },
      {
        text: "PACK ID",
        value: "pack_reference_id",
        align: "left",
        sortable: false,
      },
      {
        text: "FIRST NAME",
        value: "first_name",
        align: "left",
        sortable: false,
      },
      {
        text: "MIDDLE NAME",
        value: "middle_name",
        align: "left",
        sortable: false,
      },
      {
        text: "LAST NAME",
        value: "last_name",
        align: "left",
        sortable: false,
      },
      // {
      //   text: "E-mail",
      //   value: "email_id",
      //   align: "left",
      // },
      // {
      //   text: "PHONE NUMBER",
      //   value: "phone_number",
      //   align: "left",
      //   sortable: false,
      // },
      {
        text: "SUB-CARD TYPE",
        value: "sub_card_type",
        align: "left",
        sortable: false,
      },
      {
        text: "DATE",
        value: "created_on",
        align: "left",
        sortable: false,
      },

      {
        text: "STATUS",
        value: "status",
        align: "left",
        sortable: false,
      },
      {
        text: "CARD STATUS",
        value: "card_status",
        align: "left",
        sortable: false,
      },
      {
        text: "",
        value: "action",
        align: "left",
        sortable: false,
      },
      {
        text: "VIEW",
        value: "View",
        align: "left",
        sortable: false,
      },
    ],
    Namerules: [(v) => !!v || "required!"],
    deactivate_dialog: false,
    resubmit_dialog:false,
    Nodeactive: false,
    // deactivate_dialog2:false,
    CarduuId: "",
    ProxyNum: "",
    CorpID: "",
    UserID: "",
    FirstName: "",
    deletependingDialog: false,
   
    //   CarduuId2:"",
    // CorpID2:"",
    // UserID2:""
    // mounted: true,
  }),
  mounted() {
    this.$refs.mappeduser.ispersonalized = false;
    this.getcarduserdetails();
  },
  created() {
    //this.corponboard();
    this.status = this.statuss[0];
    this.checkaccess();
  },
  methods: {
    itemRowBackground: function (item) {
      return item.status == "Click to Assign" ? "style-1" : "";
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getuserdeatils();
      }
    },
    isViewDetailVisibile(status) {
      if (
        status === "Instock" ||
        status === "Waiting For Dispatch" ||
        status === "Waiting For Acknowledgment" ||
        status === "Mapped to User" ||
        status === "Pending Onboarding" ||
        status === "Active" ||
        status === "Mobile Number Verified" ||
        status === "Onfido KYC Pending" ||
        status === "Admin Approval Pending" ||
        status === "Admin Approval Pending - Onfido Success" ||
        status === "Admin Approval Pending - Onfido Failure" ||
        status === "Onfido Verification Failed" ||
        status === "Card Account Created" ||
        status === "Rejected" ||
        status === "Assigned to user" ||
        status === "Blocked" ||
        status === "KYC Pending" ||
        status === "KYC Failed" ||
        status === "Activation Pending" ||
        status === "Active User" ||
        status === "Pending for Deletion" ||
        status === "Pending for DELETION" ||
        status === "User deletion Rejected" ||
        status === "DELETED" ||
        status === "Card Activation Pending"
      )
        return true;
      else false;
    },
    getClassforStatus(status) {
      // this.mounted = false;
      // this.$nextTick(() => {
      //   this.mounted = true;
      // });
      switch (status) {
        case "Instock":
          return "purple--text caption";

        case "Waiting For Dispatch":
          return "yellow--text  caption";

        case "Waiting For Acknowledgment":
          return "yellow--text  caption";

        case "Ready to Assign":
          if (this.kyc == true)
            return "black--text caption font-weight-bold border 1 px solid pa-2 ml-n1 rounded-lg";
          else return "transparent--text caption";

        case "Mapped to User":
          return "green--text caption";

        case "Pending Onboarding":
          return "orange--text caption";

        case "Active":
          return "green--text caption";

        case "Mobile Number Verified":
          return "green--text  caption";

        case "Onfido KYC Pending":
          return "orange--text caption";

        case "Admin Approval Pending":
          return "orange--text  caption";

        case "Admin Approval Pending - Onfido Success":
          return "orange--text  caption";

        case "Admin Approval Pending - Onfido Failure":
          return "orange--text  caption";

        case "Onfido Verification Failed":
          return "red--text caption";

        case "Card Account Created":
          return "green--text caption";

        case "Rejected":
          return "red--text caption";

        case "Assigned to user":
          return "blue--text caption";

        case "Blocked":
          return "red--text caption";

        case "KYC Pending":
          return "orange--text caption";

        case "KYC Failed":
          return "red lighten-4--text caption";

        case "Activation Pending":
          return "orange--text caption";

        case "Active User":
          return "green--text caption";

        case "Click to Assign":
          return "black--text caption font-weight-bold border 1 px solid pa-2 ml-n1 rounded-lg";

        case "Deactivated":
          return "red--text caption";

        case "DELETED":
          return "red--text caption";
        case "Pending for Deletion":
          return "orange--text caption";
        case "Pending for DELETION":
          return "orange--text caption";
        case "User deletion Rejected":
          return "red--text caption";
        case "Card Activation Pending":
          return "orange--text caption";

        default:
          return "green darken-4--text caption";
      }
    },
    async mapuser(item) {
      if (item.status == "Ready to Assign") {
        this.$refs.mappeduser.proxy = item.proxy_number;
        this.$refs.mappeduser.name = item.full_name;
        this.$refs.mappeduser.phno = item.phone_number;
      }
    },
    opendeatils(item, data) {
      if (data == 1) {
        this.$refs.viewdetails123.viewDetailStatus = true;
        this.$refs.viewdetails123.itemsVaue = item;
        this.approver1 = item.expense_approver;
        // console.log(" this.approver1", this.approver1)
        this.approver2 = item.expense_approver_two;
        this.userbudget = item.user_budget;
        this.carddetails = item.card_details;
        this.itemUsers = item.user_type;
      }
    },
    Resubmit(item){
     
      this.FirstName = item.first_name;
      this.UserID = item.user_id;

      this.resubmit_dialog = true
    },
    async corponboard() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "FCINFO",
          corp_id: this.$store.getters.get_corpid, //"16", //"4",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responghghseData", responseData);
      if (responseData.data.data != null || responseData.data.data != "") {
        if (responseData.data.data.kyc_status == 0) {
          let userAdded = this.userDatalist.filter(
            (item) => item.user_id == responseData.data.data.userid
          );
      //  console.log("userAdded" , userAdded)
          this.kyc = false;

          if (userAdded.length == 0) {
            this.userDatalist[0].first_name = responseData.data.data.fname;
            this.userDatalist[0].middle_name = responseData.data.data.mname;
            this.userDatalist[0].last_name = responseData.data.data.lname;
            this.userDatalist[0].email_id = responseData.data.data.email_id;
            this.userDatalist[0].phone_number = responseData.data.data.mobileno;
            this.userDatalist[0].is_director =
              responseData.data.data.is_director;
            // console.log("sfgsd", this.userDatalist[0].is_director)

            this.userDatalist[0].status = "Click to Assign";
          
          }
        }
      }
    },

    async getcarduserdetailsPagination() {
      if (this.userDatalist.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "CARDS",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "CARDGET",
            corp_id: this.$store.getters.get_corpid, //"17", //, ,"4", //"4",
            status: this.status.name == "All" ? 0 : this.status.value,
            search_text: this.search,
            card_type: 2,
            sub_card_type: this.cartype == 0 ? 0 : this.cartype.value,
          },
        };

        var responseData = await apiCall(inputData);

        this.userDatalist = this.userDatalist.concat(responseData.data.data);
      }
    },
    async getcarduserdetails() {
      this.overlay = true;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "CARDGET",
          corp_id: this.$store.getters.get_corpid, //"17", //, ,"4", //"4",
          status: this.status.name == "All" ? 0 : this.status.value,
          search_text: this.search,
          card_type: 2,
          sub_card_type: this.cartype == 0 ? 0 : this.cartype.value,
        },
      };
      this.overlay = false;
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.userDatalist =
            responseData.data.data == null ? [] : responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.userDatalist = [];
        this.Nodata = responseData.data.status_msg;
      }
      // console.log("userDatalist",this.userDatalist);
      this.corponboard();
    },
    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log("responseData", responseData);
      if (responseData.data.status == "00") {
        var rowlist = responseData.data.data;
        // console.log("getuserdeatils", rowlist);
        this.$store.commit("SET_Cusdetails", rowlist);
        // rowlist.department_count = "1";
        this.overlay = false;
      }
      // console.log("getuserdeatils", responseData);
    },
    assigncard(item) {
      if (item.status == "Click to Assign" && this.kyc == false) {
        this.$refs.assigncard.assigncarddialog = true;
        this.$refs.assigncard.e1 = 1;
        this.$refs.assigncard.getDepartList();
        this.$refs.assigncard.corponboard();
        this.$refs.assigncard.is_director1 = item.is_director;

        this.$refs.assigncard.proxynumber = item.proxy_number;
      } else if (item.status == "Ready to Assign" && this.kyc == true) {
        this.$refs.assigncard.assigncarddialog = true;
        this.$refs.assigncard.e1 = 1;
        this.$refs.assigncard.getDepartList();
        this.$refs.assigncard.corponboard();
        this.$refs.assigncard.is_director1 = item.is_director = "0";
        // console.log("sdf", this.$refs.assigncard.is_director1)
        this.$refs.assigncard.proxynumber = item.proxy_number;
      }
      // if (this.userDatalist.indexOf(item) + 1 == 1 && this.kyc == false) {
      //   this.$refs.assigncard.assigncarddialog = true;
      //   this.$refs.assigncard.e1 = 1;
      //   this.$refs.assigncard.getDepartList();
      //   this.$refs.assigncard.corponboard();
      //   this.$refs.assigncard.is_director1 = item.is_director;

      //   this.$refs.assigncard.proxynumber = item.proxy_number;
      // } else if (this.kyc == true) {
      //   this.$refs.assigncard.assigncarddialog = true;
      //   this.$refs.assigncard.e1 = 1;
      //   this.$refs.assigncard.getDepartList();
      //   this.$refs.assigncard.corponboard();
      //   this.$refs.assigncard.is_director1 = item.is_director = "0";
      //   this.$refs.assigncard.proxynumber = item.proxy_number;
      // }
    },
    Deactivate(item) {
      if (item.status == "Pending for Deletion") {
        this.$store.commit("snackbar/showMessage", {
          content: "Already on pending approval",
          color: "red",
        });
      } else {
        if (item.card_balance == 0) {
          this.deactivate_dialog = true;
          this.UserID = item.user_id;
          this.CorpID = item.corp_id;
          this.CarduuId = item.card_uuid;
          this.ProxyNum = item.proxy_number;
          this.FirstName = item.first_name;
          this.CardBalance = Number(item.card_balance);
        } else if (item.card_balance != 0) {
          this.Nodeactive = true;
          this.FirstName = item.first_name;
          this.CardBalance = Number(item.card_balance);
        }
      }

      //        console.log("itsrdfem",this.CorpID);
      // console.log("isdfsdfsdftem",this.UserID);

      // console.log("iteasdasd3m",this.CarduuId);
      // console.log("iteasdasd3m",this.EmailId);
    },
    dialogclose() {
      this.deactivate_dialog = false;
    },
    dialogclosereSubmit() {
      this.resubmit_dialog = false;
    },
    
    async Deactiveuser() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "DECARD",
          corp_id: this.CorpID,
          // card_uuid: this.CarduuId,
          proxy_number: this.ProxyNum,
          user_id: this.UserID,
          initiated_by: this.$store.getters.get_userid,
          initiated_from: 2,
          workflow_type: 5,
          workflow_type_id: this.UserID,
          workflow_comments: this.comments,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        // this.$store.commit("snackbar/showMessage", {
        //   content: responseData.data.status_msg,
        //   color: "green",
        // });
        this.deletependingDialog = true;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
      this.deactivate_dialog = false;
      this.dialogapprv = false;
      this.$refs.form.reset();
    },
    closeDialog() {
      this.deletependingDialog = false;
      this.getcarduserdetails();
    },
    dialogcloseApprv() {
      this.dialogapprv = false;
    },
    dialogcloseApprvnew() {
      this.Nodeactive = false;
    },

    Deactive() {
      if (this.$refs.form.validate()) {
        this.dialogapprv = true;
      }
    },
   async ResubmitCnfrm(){
      this.loading = true;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "USERRESUBMIT",
          user_id: this.UserID,
       
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.resubmit_dialog = false;
        this.getcarduserdetails();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.resubmit_dialog = false;
      }
      this.resubmit_dialog = false;
      this.loading = false
    }
    //     Activate(item){
    //           this.deactivate_dialog2 = true;
    //     console.log("item",item);
    //  this.UserID2 = item.user_id;
    //     this.CorpID2 = item.corp_id;
    //     this.CarduuId2 = item.card_uuid;

    //     },
    // dialogclose2() {

    //   this.deactivate_dialog2 = false;
    // },

    // activeuser(){

    // }
  },
};
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
.greencolor {
  color: green;
}
.bluecolor {
  color: rgb(0, 140, 255);
}
.bluecolor:hover {
  cursor: pointer;
}
.orangecolor {
  color: orange;
}
.orangecolor:hover {
  cursor: pointer;
}
.clr:hover {
  cursor: pointer;
}
.clr {
  color: darkturquoise;
}
.v-data-table .status:hover {
  cursor: pointer;
}
.style-1 {
  background-color: #b0bec5;
  /* -webkit-text-fill-color: black; */
}
</style>
